import React from "react";
import { Loader } from 'pixi.js'
import { AnimatedSprite, Container } from '@inlet/react-pixi'

let starTextures = [];

const MaxLevelEffect = ({ xPos, yPos, isVisible }) => {
    const loader = Loader.shared;
    for (let i = 1; i <= 8; i++) {
        starTextures.push(loader.resources["./assets/images/components/island/spritesheets/seaAssets/sea_sparkle.json"].textures[`firework${i}.png`]);
    }

    return (
        <Container  position={[xPos, yPos]} visible={isVisible}>
            <AnimatedSprite
                anchor={0.5}
                textures={starTextures}
                isPlaying={true}
                initialFrame={0}
                scale={{ x: 0.3, y: 0.3}}
                x={145}
                y={120}
                animationSpeed={0.1}
            />
            <AnimatedSprite
                anchor={0.5}
                textures={starTextures}
                isPlaying={true}
                initialFrame={0}
                scale={{ x: 0.3, y: 0.3 }}
                x={200}
                y={150}
                animationSpeed={0.1}
            />
            <AnimatedSprite
                anchor={0.5}
                textures={starTextures}
                isPlaying={true}
                initialFrame={0}
                scale={{ x: 0.3, y: 0.3 }}
                x={220}
                y={90}
                animationSpeed={0.1}
            />
            <AnimatedSprite
                anchor={0.5}
                textures={starTextures}
                isPlaying={true}
                initialFrame={0}
                scale={{ x: 0.3, y: 0.3 }}
                x={160}
                y={60}
                animationSpeed={0.1}
            />
        </Container>
    );
};

export default MaxLevelEffect;